import React, { useMemo } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Box, Typography } from '@mui/material';
import GaussianBellCurve from './GaussianBellCurve'; // Assuming GaussianBellCurve is in the same directory

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function PerformanceByLeader({ leaderName, allEvaluations }) {
  // Filter evaluations for the selected leader
  const leaderEvaluations = useMemo(() => {
    if (!leaderName || !allEvaluations || allEvaluations.length === 0) return [];
    return allEvaluations.filter(evalItem => {
      // Assuming 'lider' property exists in the evaluation object within allEvaluations
      // Also, considering the 'legajo' from allEvaluations to link to 'colaboradores' in trendsData
      // This might require a more robust way to link, but for now, assuming evaluation.lider exists
      return evalItem.lider === leaderName;
    });
  }, [leaderName, allEvaluations]);

  // Extract original and calibrated score distributions
  const originalDistribution = useMemo(() => {
    const distribution = {};
    leaderEvaluations.forEach(evalItem => {
      const score = evalItem.puntaje; // Original score
      distribution[score] = (distribution[score] || 0) + 1;
    });
    return distribution;
  }, [leaderEvaluations]);

  const calibratedDistribution = useMemo(() => {
    const distribution = {};
    leaderEvaluations.forEach(evalItem => {
      const score = evalItem.puntaje_calibrado; // Calibrated score
      distribution[score] = (distribution[score] || 0) + 1;
    });
    return distribution;
  }, [leaderEvaluations]);

  if (!leaderName) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="subtitle1">Seleccione un líder para ver su desempeño detallado.</Typography>
      </Box>
    );
  }

  if (leaderEvaluations.length === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="subtitle1">No hay datos de evaluaciones para el líder seleccionado en este período.</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <GaussianBellCurve 
        distribution={calibratedDistribution}
        originalDistribution={originalDistribution} // Pass original distribution for comparison
        title={`Distribución de Puntajes para ${leaderName}`}
      />
    </Box>
  );
} 